export default __webpack_public_path__ + "static/media/1.324993d4.jpg";